import { Widget } from "./baseWidget";

export class Table extends Widget{
  type = 'table';
  config = {
    props: [],
  };
}
